import { useState } from 'react';
import { Box } from '@mui/material';
import StudentCard from './StudentCard';
import StudentSearchBox from './StudentSearchBox';
import './StudentList.scss';

const StudentList = ({ listStudents, onAdd }) => {
  const [searchResult, setSearchResult] = useState(listStudents);

  const updateSearchResult = (value) => {
    setSearchResult(value);
  };

  return (
    <Box display='flex' flexDirection='column' className='student-list-box'>
      <Box data-test='student-list-search-student' className='search-section'>
        <StudentSearchBox updateSearchResult={updateSearchResult} listStudents={listStudents} />
      </Box>
      <Box className='search-result-existing-student'>
        {searchResult.map((student) => (
          <Box width={160}>
            <StudentCard
              key={student.id || `${student.attributes.userName}-${student.attributes.firstName}-${student.attributes.lastName}`}
              student={student}
              onAdd={onAdd}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default StudentList;
